import PropTypes from 'prop-types';

export const PermissionType = PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
});

export const RoleType = PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    //permissions: PropTypes.arrayOf(PermissionType).isRequired
});

export const UserType = PropTypes.shape({
    id: PropTypes.number,
    email: PropTypes.string,
    //avatar: PropTypes.string,
    //roles: PropTypes.arrayOf(RoleType).isRequired
});



// WEBPACK FOOTER //
// ./src/types/user.js